"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ShortcutBase_1 = require("./ShortcutBase");

var shortcuts_1 = require("../../../models/query/scenarioStatistics/shortcuts");

var scenarioStatistics_1 = require("../../../models/query/scenarioStatistics");

var FundsShortcut =
/** @class */
function (_super) {
  __extends(FundsShortcut, _super);

  function FundsShortcut(scenarioStatisticQuery) {
    return _super.call(this, scenarioStatistics_1.ScenarioStatisticShortcut.funds, shortcuts_1.ShortcutType.rootOptions, scenarioStatisticQuery) || this;
  }

  FundsShortcut.prototype.getRootOptions = function (shortcutOptions) {
    var _a = shortcutOptions.options,
        options = _a === void 0 ? {} : _a,
        _b = shortcutOptions.periods,
        periods = _b === void 0 ? {} : _b,
        _c = shortcutOptions.portfolios,
        portfolios = _c === void 0 ? {} : _c,
        _d = shortcutOptions.portfolioEntities,
        portfolioEntities = _d === void 0 ? {} : _d;
    var response = this.scenarioStatisticQuery.shortcuts.portfolios.getRootOptions(__assign(__assign({}, shortcutOptions), {
      options: {
        portfolios: {
          key: 'funds',
          options: {
            funds: __assign(__assign({}, portfolioEntities), options.funds || {})
          }
        }
      }
    }));
    return response;
  };

  return FundsShortcut;
}(ShortcutBase_1.ShortcutBase);

exports.FundsShortcut = FundsShortcut;